import React from 'react';
import { useLocalizedText } from '../../../hooks/localizedText';
import { Container, Spinner } from '@amzn/awsui-components-react';
import { Event, Shift } from '@amzn/red-velvet-api';

import { useUrlPage } from '../../../hooks/attendance/urlPage';
import { FIRST_PAGE } from '../wizard/attendanceWizard';

import {
  DISPLAY_ATTRIBUTES_TYPE,
  DISPLAY_COORDINATOR_INFO,
  DISPLAY_DATE_INFO,
  DISPLAY_LOCATION_INFO,
  DISPLAY_VC_INFO,
} from '../../shifts/shiftInfo';
import { ShiftCard, ShiftHeader } from './shiftCard';

interface ShiftAttendanceHeaderProps {
  event: Event;
  shift: Shift;
  isFetched: boolean;
}

export function ShiftAttendanceHeader({ event, shift, isFetched }: ShiftAttendanceHeaderProps) {
  const namespaces = ['attendance', 'translation'];
  const { t } = useLocalizedText(namespaces);
  const { page } = useUrlPage(FIRST_PAGE);

  // If we are loading any data, we want to display a loading spinner
  if (!isFetched) {
    return (
      <Container>
        <Spinner />
        <span>{t('fullEvent.loadingEvent')}</span>
      </Container>
    );
  }

  const displayAttributes: DISPLAY_ATTRIBUTES_TYPE[] = [
    DISPLAY_LOCATION_INFO,
    DISPLAY_COORDINATOR_INFO,
    DISPLAY_DATE_INFO,
  ];
  if (page !== FIRST_PAGE) displayAttributes.push(DISPLAY_VC_INFO);

  return (
    <Container>
      <ShiftHeader event={event} />
      <ShiftCard event={event} shift={shift} displayAttributes={displayAttributes} />
    </Container>
  );
}
